export enum ViolationFixGradesEnum {
  CORRECT = 'CORRECT',
  NOT_CORRECT = 'NOT_CORRECT',
}
